export const queryKeys = {
  auth: {
    me: ['auth', 'me'] as const,
  },
  timeEntries: {
    all: ['timeEntries'] as const,
    list: (filters?: Record<string, unknown>) => ['timeEntries', 'list', filters] as const,
    detail: (id: string) => ['timeEntries', 'detail', id] as const,
    current: ['timeEntries', 'current'] as const,
    summary: ['timeEntries', 'summary'] as const,
  },
  projects: {
    all: ['projects'] as const,
    list: () => ['projects', 'list'] as const,
    listWithTrackedHours: () => ['projects', 'list', 'withTrackedHours'] as const,
    accessible: () => ['projects', 'accessible'] as const,
    detail: (id: string) => ['projects', 'detail', id] as const,
    members: (projectId: string) => ['projects', 'members', projectId] as const,
  },
  clients: {
    all: ['clients'] as const,
    list: () => ['clients', 'list'] as const,
    detail: (id: string) => ['clients', 'detail', id] as const,
  },
  reports: {
    summary: (filters?: Record<string, unknown>) => ['reports', 'summary', filters] as const,
    detailed: (filters?: Record<string, unknown>) => ['reports', 'detailed', filters] as const,
    weekly: (filters?: Record<string, unknown>) => ['reports', 'weekly', filters] as const,
    smartSummary: (filters?: Record<string, unknown>) =>
      ['reports', 'smartSummary', filters] as const,
    smartDetails: (filters?: Record<string, unknown>) =>
      ['reports', 'smartDetails', filters] as const,
  },
  team: {
    all: ['team'] as const,
    members: () => ['team', 'members'] as const,
  },
  workspace: {
    current: ['workspace', 'current'] as const,
  },
  settings: {
    current: ['settings', 'current'] as const,
  },
  config: {
    features: ['config', 'features'] as const,
  },
  dashboard: {
    summary: (from: string, to: string, userId?: string) => ['dashboard', 'summary', from, to, userId] as const,
    teamActivity: (from: string, to: string, userId?: string) => ['dashboard', 'teamActivity', from, to, userId] as const,
  },
} as const;
